var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShareAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 18.7605V16H19.7143V18.0704H12H4.28572V16H3V18.7605L3.64286 19.4506H20.3571L21 18.7605Z",
    fill: "#15355C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2932 7.16962V5.18858L21.0476 9.94307L16.2932 14.6975V12.7165L19.0666 9.94307L16.2932 7.16962Z",
    fill: "#15355C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0335 7.80359C6.32814 8.18394 3.63393 13.192 3 15.8862C4.14108 12.463 9.49779 11.4487 12.0335 11.6072V15.4108L17.7389 9.70538L12.0335 4V7.80359Z",
    fill: "#15355C"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareAll);
export default __webpack_public_path__ + "static/media/shareAll.bf830d58b7805150b4446be18d271d61.svg";
export { ForwardRef as ReactComponent };